<!--该页面为了兼容插件，无实际使用-->
<template>
<div></div>
</template>

<script>
export default {
  name: 'viewsHead',
  data () {
    return {};
  },
  created () {},
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
